"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DDS = void 0;
exports.DDS = {
    validate(buffer) {
        return buffer.readUInt32LE(0) === 0x20534444;
    },
    calculate(buffer) {
        return {
            height: buffer.readUInt32LE(12),
            width: buffer.readUInt32LE(16)
        };
    }
};
